// components/RedirectLoader.tsx
import React from 'react';
import { motion } from 'framer-motion';

interface ShowLoaderProps {
    text?: string; // optional prop
}

const ShowLoader: React.FC<ShowLoaderProps> = ({ text = 'Redirecting...' }) => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-black via-[#0a0a0a] to-[#1a1a1a] flex flex-col items-center justify-center z-50 overflow-hidden">
      {/* Background glow effect */}
      <motion.div
        className="absolute w-[400px] h-[400px] bg-orange-500/20 rounded-full blur-3xl"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: [0.8, 1.1, 0.9], opacity: [0.3, 0.5, 0.4] }}
        transition={{ repeat: Infinity, duration: 3, ease: 'easeInOut' }}
      />

      {/* Logo */}
      <motion.img
        src="/Dinelyt_Transparent_BrandLogo.png"
        alt="Dinelyt"
        className="w-24 h-24 mb-6 relative z-10 drop-shadow-[0_0_20px_rgba(255,115,0,0.8)]"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      />

      {/* Spinner */}
      <motion.div
        className="w-12 h-12 border-[3px] border-orange-400 border-t-transparent rounded-full animate-spin relative z-10 shadow-[0_0_20px_#ff6600]"
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1 }}
      />

      {/* Glowing text */}
      <motion.p
        className="mt-6 text-orange-400 font-medium text-lg tracking-wide relative z-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: [0.4, 1, 0.4] }}
        transition={{ repeat: Infinity, duration: 2 }}
      >
       {text}
      </motion.p>
    </div>
  );
};

export default ShowLoader;

